<div class="wrapper">
  <div class="header flex justify-between items-start">
    <div class="left flex gap-[20px]">
      <div class="image-section">
        <mat-icon
          [svgIcon]="icon"
          class="category-icon"
          />
      </div>
      <div class="details-section flex flex-col justify-center items-start">
        <div class="heading text-type-6 mb-[4px]">{{ heading }}</div>
        <div class="subheading text-type-10">{{ subheading }}</div>
      </div>
    </div>
    <div class="right">
      <mat-icon
        [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
        class="chevron"
        />
    </div>
  </div>
  @if (isExpanded) {
    <div class="content">
      <ng-content />
    </div>
  }
</div>
